import { createFileRoute } from "@tanstack/react-router";

import RegisterPage from "@/components/Register/RegisterPage";

export const Route = createFileRoute("/register")({
  component: RegisterPage,
});
